<app-protocolo-envio
    [titulo]="titulo"
    [instrucoesEnvio]="instrucoesEnvio"
    [routerLinkPesquisaLote]="['/atualizacao-info-risco/pesquisa']"
    [tipoConteudoArquivo]="tipoConteudoArquivo"
    [janelaEnvioAtual]="janelaAtual"
     [permitirForaJanela]="permitirForaJanela"
    *ngIf="janelaAtual"
    [tipoArquivoAceito]="'csv'"
>
</app-protocolo-envio>


